/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, DatePicker } from "antd";

export function FormDatePicker({
  id,
  name = "",
  label,
  required,
  ...rest
}: any) {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={[
        {
          required: required,
          message: `Please select ${label.toLowerCase()}!`,
        },
      ]}
      layout="vertical"
    >
      <DatePicker style={{ width: "100%" }} {...rest} />
    </Form.Item>
  );
}
